import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { db } from '../../Firebase/Firebase'; // Asegúrate de importar tu configuración de Firebase
import LoadingScreen from '../../Components/loading';
import Navbar from '../../Components/NavBarAirbnbStyle';
import FloatingWhatsApp from '../../Components/whatsappbutton';
import Footer from '../../Components/footer';
import './AdministrarMarca.css';
const AdministrarMarcas = () => {
    const [marcas, setMarcas] = useState([]);
    const [loading, setLoading] = useState(true);

    const auth = getAuth();
    const user = auth.currentUser; // Obtén el usuario logueado

    // Obtener marcas asociadas al usuario logueado
    useEffect(() => {
        if (user) {
            fetchMarcas(user.uid);
        }
    }, [user]);

    const fetchMarcas = async (userId) => {
        try {
            // Buscar el documento del usuario
            const userDocRef = doc(db, 'usuarios', userId);
            const userDocSnap = await getDoc(userDocRef);

            if (userDocSnap.exists()) {
                const userData = userDocSnap.data();
                const marcasIds = userData.marcas || []; // Obtener marcas asociadas (array de IDs)

                if (marcasIds.length > 0) {
                    // Buscar las marcas en la colección 'marcas' usando los IDs
                    const marcasPromises = marcasIds.map(async (marcaId) => {
                        const marcaRef = doc(db, 'marca', marcaId);
                        const marcaSnap = await getDoc(marcaRef);

                        return marcaSnap.exists() ? marcaSnap.data() : null;
                        
                    });

                    // Obtener las marcas asociadas
                    const marcasList = await Promise.all(marcasPromises);
                    setMarcas(marcasList.filter((marca) => marca !== null)); // Filtrar marcas válidas
                }
            }
            setLoading(false);
        } catch (error) {
            console.error('Error al obtener las marcas:', error);
            setLoading(false);
        }
    };

    if (loading) {
        return <LoadingScreen />; // Muestra un mensaje mientras se cargan los datos
    }

    return (
        <>
            <Navbar />
            <FloatingWhatsApp />
            <h2>Administrar tus Marcas</h2>

            <div className="marcas-container">
                {marcas.length === 0 ? (
                    <p>No tienes marcas asociadas aún.
                        <a href='/create-marca'> Agrega una marca</a>
                    </p>

                ) : (
                    marcas.map((marca) => (
                        <div key={marca.id} className="marca-card">
                            <Link to={`/proveedor/marca/${marca.id}`} className="marca-link">
                                <img src={marca.logo} alt={marca.nombre} className="marca-logo" />
                                <h3 className="marca-nombre">{marca.nombre}</h3>
                            </Link>
                        </div>
                    ))
                )}
            </div>
            <Footer />
        </>

    );
};

export default AdministrarMarcas;
